import { LaravelResponse, keyToUrl } from "@dgs/core";
import axios from "axios";
import { ModuleSettingsEventResource, ModuleSettingsSaveRequest } from "../types/moduleSettings";

const baseKey = ["module-settings"];

export const moduleSettingService = {
	baseKey,
	show: () => {
		return axios.get<LaravelResponse<ModuleSettingsEventResource>>(keyToUrl(baseKey));
	},
	update: (moduleSettings: ModuleSettingsSaveRequest) => {
		return axios.put(keyToUrl(baseKey), moduleSettings);
	},
};
